import { z } from 'zod';

export const zodUpdateInvoiceParsingInputEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
  z.literal('parsing_input'),
]);

export const zodInvoiceParsingInputFileDataSchema = z.object({
  fileContent: z.string().min(1),
  fileType: z.enum(['application/json', 'application/xml']),
  fileName: z.string().min(1),
});
